import React, { Component } from 'react';
import Title from '../../helper/title';
import Asset from './asset.jsx';
import Import from './import.jsx';
import './asset.css';
import {assets} from '../../../config';
import {isMobile} from 'react-device-detect';
import Modal from "../../helper/modal";
import QRCode from 'react-qr-code';
import { connect } from "react-redux";
import M from 'materialize-css/dist/js/materialize.min.js'

class Assets extends Component {
  constructor(){
    super();
    this.state = {address:''}
  }
  renderQRCode(){
    let component = (
      <div className='row mbd' style={{textAlign:'center'}}>
        <p style={{fontSize:'13px',marginTop:'15px',marginBottom:'15px'}}>{this.props.addressText}</p>
        <QRCode style={{marginBottom:'10px'}} value={this.props.addressText} />
        <p style={{fontSize:'13px',marginTop:'15px'}}></p>
      </div>
    )
    return (
      <Modal title='View QR Code' id='modalQR' style={{maxWidth:'400px'}} classes='modal modalOrders black-text' noClose={true} component={component} />
    )
  }
  setAddress(address){
    this.setState({address})
    var instance = M.Modal.getInstance(document.querySelectorAll('#modalQR')[0]);
    if(instance) instance.open();
  }
  render() {
    return (
      <div className="col s12 m2 assets" style={{padding:0,borderRight:isMobile ? 'none': '1px solid grey'}}>
        <Title text='assets' />
        <Import/>
        <div className="col s12" id='wallets' >
          {assets.map((a,index)=>(
            <Asset key={index} setAddress={this.setAddress.bind(this)} index={index} title={a.toLowerCase()} asset={a.toLowerCase()} div={`${a.toLowerCase()}div`} />
          ))}
        </div>
        {this.renderQRCode()}
      </div>
    )
  }
}


function mapStateToProps(state, props) {
  return {
    addressText: state.ui_passport.address_view
      ? state.ui_passport.address_view.toLowerCase()
      : ""
  };
}

export default connect(mapStateToProps, {
})(Assets);
